import { useTranslation } from 'react-i18next';

import { BlueButton } from 'libs/ui';
import { Content } from './add.styled';

export const ReceiptAdd = (props) => {
  const { t } = useTranslation();

  return (
    <Content>
      <BlueButton onClick={props.addNew} disabled={props.show}>
        {t('buttons.Новый шаблон')}
      </BlueButton>
    </Content>
  );
};
